export const PLAYER_ID_TOKEN = 'ops_id_token';
export const PLAYER_REFRESH_TOKEN = 'ops_refresh_token';
export const PLAYER_ACCESS_TOKEN = 'ops_access_token';

export const ADMIN_ID_TOKEN = 'ops_admin_id_token';
export const ADMIN_ACCESS_TOKEN = 'ops_admin_access_token';